import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Link,
  IconButton,
  TableHead,
  TableContainer,
  Paper,
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import { AiOutlineLine } from 'react-icons/ai';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import { RiCheckFill } from 'react-icons/ri';
import { RiFilterLine } from 'react-icons/ri';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenSelect from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import KenPopover from '../../../Components/KenPopOver';
import {
  selectOptions,
  todayDropDown,
  intakeOptions,
  selectOptionsSection,
  courses,
  yearOptions,
  modeDropdown,
} from './data/data';
import KenInputField from '../../../global_components/KenInputField';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import ProgramFilter from './ProgramFilter';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import KenSnackbar from '../../../Components/KenSnackbar/index';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import './addActivity.css';
import {
  getAcademicFilter,
  getAcademicPlannerData,
  postAcademicPlanner,
  getMasterActivityWithTermData,
  getImportTermActivity,
  getFacultyAndFacilty,
  updateReferenceActivities,
  getCourseVersion,
} from '../../../Utils/apiServices';
import Reference from '../FullCalendar/Reference';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  dateLabels: {
    lineHeight: '42px',
    marginRight: '10px',
    fontSize: '12px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));

const ActionCell = (row) => {
  return (
    <Box>
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlinePencilAlt className="m-0" />}
      >
        Edit
      </Button>{' '}
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlineTrash className="m-0" />}
      >
        Delete
      </Button>
    </Box>
  );
};

const createData = (
  id,
  weekNo,
  activity,
  startDate,
  endDate,
  facultyList,
  saved
) => ({
  id,
  weekNo,
  activity,
  startDate,
  endDate,
  facultyList,
  saved,
});
const selectOptionsSubject = [
  { label: 'Teaching', value: 'Teaching' },
  { label: 'Exam', value: 'Exam' },
  { label: 'Lab', value: 'Lab' },
  { label: 'Tutorial', value: 'Tutorial' },
  { label: 'Practical', value: 'Term Break' },
  { label: 'Workshop', value: 'Workshop' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Term Break', value: 'Term Break' },
  { label: 'Holiday', value: 'Holiday' },
  { label: 'Other', value: 'Other' },
];

const defaultValues = {
  programFrom: '',
  intakeFrom: '',
  courseFrom: '',
  startDateFrom: '',
  endDateFrom: '',
  programTO: '',
  intakeTO: '',
  courseTO: '',
  startDateTO: '',
  endDateTO: '',
};

const AddActivity = (props) => {
  const history = useHistory();
  const {
    programName,
    intake,
    year,
    selectedRow,
    newAddActivity,
    activitiesData,
    facultyOption,
    currentRow,
    onReload,
    createNewActivity,
    setCreateNewActivity,
  } = props;
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = React.useState('Online');
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [term, setTerm] = useState();
  const [termDropdown, setTermDropdown] = useState([]);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [endDate, setEndDate] = useState('25-02-2022');
  const [termStart, setTermStart] = useState('');
  const [termEnd, setTermEnd] = useState('');
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [masterAccordian, setMasterAccordian] = useState(true);
  const [selectSectionValue, setSelectSectionValue] = useState(
    selectOptionsSection[0].value
  );
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const [formValues, setFormValues] = useState(defaultValues);
  const [loading, setLoading] = React.useState(false);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [masterDialog, setMasterDialog] = useState(false);
  const [masterImportSuccess, setMasterImportSuccess] = useState(false);
  const [disableMaster, setDisableMaster] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEls, setAnchorEls] = useState(null);
  const [anchorElIgnore, setAnchorElIgnore] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filters, setFilters] = useState({});
  const [ignoreHoliday, setIgnoreHoliday] = useState(false);
  const [filterProgram, setFilterProgram] = useState(false);
  const [previous, setPrevious] = useState({});
  const [gradeInp, setGradeInp] = useState({});
  const [dataStream, setDataStream] = useState({});
  const [accordienSecondCheck, setAccordienSecondCheck] = useState(false);
  const [accordienThirdCheck, setAccordienThirdCheck] = useState(false);
  const [accordienFourthCheck, setAccordienFourthCheck] = useState(false);
  const [newActivity, setNewActivity] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [toMode, setToMode] = useState('Online');
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const ignoreOpen = Boolean(anchorElIgnore);
  const ignoreIds = ignoreOpen ? 'simple-popover' : undefined;
  const [nextApproved, setNextApproved] = useState(true);
  const [locationData, setLocationData] = useState();
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [weekNo, setWeekNo] = useState();
  const [disableAddActivity, setDisableAddActivity] = useState(false);
  const [programID, setProgramID] = useState('');
  const [confirmDialogAddReference, setConfirmDialogAddReference] =
    useState(false);
  const [sessions, setSessions] = useState([]);
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [sessionValue, setSessionValue] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  const [allSubjects, setAllSubjects] = useState([]);
  const [sections, setSections] = useState([]);
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const masterHead = [
    {
      Header: 'Week No.',
      accessor: 'durationInWeeks',
      disableGlobalFilter: false,
    },
    {
      Header: 'Activity',
      accessor: 'activity',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'subject',
      disableGlobalFilter: false,
    },
    {
      Header: 'Faculty',
      accessor: 'faculty',
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      disableGlobalFilter: false,
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      disableGlobalFilter: false,
    },
    {
      Header: 'Faculty',
      accessor: 'facultyList',
      disableGlobalFilter: false,
      Cell: ({ value, row }) => {
        return (
          <Box>
            <KenAutoComplete
              options={facultyOptions}
              value={value}
              variant="outlined"
              onChange={(e, value) => onChange(e, row, value)}
              required
            />
          </Box>
        );
      },
    },
  ];

  useEffect(async () => {
    const faciltiyAndFacultyData = await getFacultyAndFacilty();

    const AllFacultyObject = Object.values(faciltiyAndFacultyData.Faculty);
    const facilitys = Object.values(faciltiyAndFacultyData);
    const activityData = Object.values(faciltiyAndFacultyData?.Activity);
    const activitySession = activityData.map((e) => {
      return { label: e.label, value: e.value };
    });
    setSessions(activitySession);
    const AllfacultyData = facultyOption.map((fData) => {
      return { title: fData.label, value: fData.value };
    });
    setFacultyOptions(AllfacultyData);

    // all subjects fetch
    // const versionData = await getCourseVersion('2023-JAN-GMBA-Term1-Dubai');
    // if (versionData.length > 0) {
    //   setAllSubjects(versionData);
    //   const versionDataConvert = Object.values(versionData);
    //   const subjectName = versionDataConvert[0]?.map((data) => {
    //     return { label: data.courseName, value: data.id };
    //   });
    //   // const newSubjectName = [...subjectName, { label: '--', value: '' }];
    //   setSubjects(subjectName);
    // }
  }, []);

  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const handleChangedEndDated = (e) => {
    setEndDate(e.target.value);
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleToModeChange = (event) => {
    setToMode(event.target.value);
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.activiteId === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const handleInputChange = (e) => {
    console.log('e.target', e.target);
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const onRevert = (id, rows, index) => {
    const newData = [...rows];
    newData.map((row) => {
      if (row.activiteId === id) {
        return (row.isEditMode = false);
      }
    });
    setRows(newData);
    setDisableAddActivity(false);
  };

  const handleSelectChangeSubject = (event) => {
    dataStream.activity = event.target.value;
    setSelectValueSubject(event.target.value);
  };
  const handleChangedCredit = (event) => {
    dataStream.durationInWeeks = event.target.value;
  };
  const handleChangedDate = (event) => {
    dataStream.startDate = event.target.value;
  };
  const handleChangedEndDate = (event) => {
    dataStream.endDate = event.target.value;
  };
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const handlePopoverOpen = (event) => {
    setAnchorEls(event.currentTarget);
  };

  const handleSelectSubjectChange = (e) => {
    console.log('handleSelectSubjectChange');
    setSelectSubjectValue(e.target.value);
    const subjectData = Object.values(allSubjects);
    const sectionData = subjectData[0]?.filter(
      (ele) => ele.id == e.target.value
    );
    const sectionDropdown =
      subjectData &&
      subjectData.length > 0 &&
      sectionData[0]?.courseOffering?.map((dataEle) => {
        return { label: dataEle.courseSectionId, value: dataEle.id };
      });
    setSections(sectionDropdown);
  };
  const [rows, setRows] = useState([]);
  const [rowSecond, setRowSecond] = useState([]);

  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    newData.forEach((newItem) => {
      if (newItem.activiteId === id) {
        newItem.isEditMode = true;
        if (check === 'done') {
          setLoading(true);
          let facultyIds = [];
          newItem.facultyList.forEach((item) => {
            facultyIds.push(item.value);
          });
          let faculty = facultyIds.join(';');
          const objRef = {
            Operation: 'Create',
            Activity: {
              termId: currentRow?.termId,
              courseVersionId: selectedRow[0].courseVersionId,
              activityId: newItem?.activiteId,
              activityType: newItem.activiteType,
              activityStartDate: `${newItem.startDate}T00:00:00.000Z`,
              activityEndDate: `${newItem.endDate}T00:00:00.000Z`,
              facultyIds: faculty,
              // activityEndDate: '2022-06-30T00:00:00.000Z',  // date formate use to send
            },
          };
          console.log('objRef', objRef);
          updateReferenceActivities(objRef)
            .then((res) => {
              setRows([]);
              setLoading(false);
              handleSnackbarOpen('success', res.message);
              newItem.isEditMode = false;
              setRows(newData);
              setDisableAddActivity(false);
              console.log('newDat', newData);
            })
            .catch((err) => {
              handleSnackbarOpen('error', 'Failed to add. Please try again.');
              setLoading(false);
              newItem.isEditMode = false;
              setRows(newData);
              console.log('newDat', newData);
              setDisableAddActivity(false);
            });
        } else if (check === 'edit') {
          setDisableAddActivity(true);
          newItem.isEditMode = true;
          setRows(newData);
        }
      }
    });
    setEditIndex(index);
  };

  const onChange = (e, row, multiVal) => {
    if (!previous[row.activiteId]) {
      setPrevious((state) => ({ ...state, [row.activiteId]: row }));
    }
    if (multiVal != undefined) {
      if (multiVal.length <= 3) {
        const newData = [...rows];
        newData[editIndex]['facultyList'] = multiVal;
        setRows(newData);
        return (row.facultyList = multiVal);
      } else {
        handleSnackbarOpen('info', 'Maximum of 3 faculties can be selected.');
      }
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newData = [...rows];
    newData[editIndex][e.target.name] = value;
    setRows(newData);
  };
  const handleRefereceCreate = (check, id, index) => {
    console.log('rows================', rows);
    setConfirmDialogAddReference(true);
    let termName = id.courseName;
    console.log('termName-----------', termName);
  };
  const onSuccess = () => {
    setConfirmDialogAddReference(false);
    onReload();
  };
  const handleSubject = (check, id, index) => {
    setDisableAddActivity(true);
    if (check == 'save') {
      setLoading(true);
      let savedData = dataStream;
      let facultyIds = [];
      savedData.facultyList.forEach((item) => {
        facultyIds.push(item.value);
      });
      let faculty = facultyIds.join(';');
      const objRef = {
        Operation: 'Create',
        Activity: {
          termId: currentRow?.termId,
          courseVersionId: selectedRow[0].courseVersionId,
          activityId: savedData?.activiteId,
          activityType: savedData.activiteType,
          activityStartDate: `${savedData.startDate}T00:00:00.000Z`,
          activityEndDate: `${savedData.endDate}T00:00:00.000Z`,
          facultyIds: faculty,
          // activityEndDate: '2022-06-30T00:00:00.000Z',  // date formate use to send
        },
      };
      updateReferenceActivities(objRef)
        .then((res) => {
          console.log('res', res);
          id.forEach((item) => {
            item.isEditMode = false;
          });
          setNewActivity(!newActivity);
          setLoading(false);
          setDisableAddActivity(false);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', 'Failed to add. Please try again.');
          setDisableAddActivity(false);
        });
    } else {
      const newData = [...rows];
      newData.push(
        createData(
          `rows${rows.length}`,
          <p>{weekNo}</p>,
          <KenSelectWrap
            label="Activity"
            options={selectOptionsSubject}
            value={dataStream.activity}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject}
            required
          />,
          <KenInputField
            label="Duration"
            value={dataStream.durationInWeeks}
            dropdownColor="#FFFFFF"
            onChange={handleChangedCredit}
            required
          />,
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            value={dataStream.startDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            value={dataStream.endDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedEndDate(e)}
          />,
          true
        )
      );
      setRows(newData);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEls(null);
  };

  // React.useEffect(() => {
  //   setLoading(true);
  //   let locationData = history?.location?.state?.batchName;
  //   setLocationData(locationData);
  //   getAcademicFilter()
  //     .then((res) => {
  //       let courseOptions = [];
  //       let campusOptions = [];
  //       Object.entries(res['Academic Program']).map(([item, keyVal]) => {
  //         courseOptions.push({
  //           label: item,
  //           value: item,
  //           id: keyVal.id,
  //           terms: JSON.parse(keyVal.terms),
  //         });
  //       });
  //       Object.entries(res['Campus']).map(([item, keyVal]) => {
  //         campusOptions.push({ label: item, value: item });
  //       });
  //       setCourseOptions(courseOptions);
  //       setCampusOptions(campusOptions);
  //       if (locationData != undefined) {
  //         let e = { target: { name: 'program', value: locationData } };
  //         handleFilter(e, courseOptions);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // }, []);

  // React.useEffect(() => {
  //   setLoading(true);
  //   let data;
  //   term != undefined
  //     ? (data = `?programName=${programName}&termName=${term}`)
  //     : intake != undefined && year != undefined
  //     ? (data = `?programName=${programName}&intake=${intake}&year=${year}`)
  //     : year != undefined
  //     ? (data = `?programName=${programName}&year=${year}`)
  //     : intake != undefined
  //     ? (data = `?programName=${programName}&intake=${intake}`)
  //     : (data = `?programName=${programName}`);
  //   if (programName != undefined && intake != undefined && year != undefined) {
  //     setNextApproved(false);
  //     setDisableMaster(false);
  //   }
  //   getAcademicPlannerData(data)
  //     .then((res) => {
  //       let responseData = res?.message;
  //       if (responseData === 'No Data Found') {
  //         setRows([]);
  //       } else {
  //         console.log('resssssssssssssssssssssssssss', res);
  //         let key = Object.keys(res);
  //         let values = Object.values(res);
  //         let alteredData = key.map((el, ind) => {
  //           return {
  //             courseName: el,
  //             array: [...values[ind]],
  //             termStart: '',
  //             termEnd: '',
  //           };
  //         });
  //         console.log(alteredData, 'alteredData');
  //         setRows(alteredData);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, [programName, term, intake, year, newActivity, masterImportSuccess]);

  React.useEffect(() => {
    setRows([]);
    setTimeout(() => {
      setConfirmDialogAddReference(false);
      setRows(activitiesData);
    }, 1000);
  }, [activitiesData]);
  const opens = Boolean(anchorEls);
  const ids = opens ? 'simple-popover' : undefined;
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleSelectOptionChange = (e) => {
    setSelectSectionValue(e.target.value);
  };

  const handleFilter = (e, data) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    if (e.target.name === 'program') {
      let newData = data.filter((element) => {
        return element.label === e.target.value;
      });
      let termData = [];
      newData[0]?.terms.map((item) => {
        termData.push({ label: item.name, value: item.name });
      });
      termData.push({ label: 'All', value: 'All' });
      setSelectedAcademicProgram(newData);
      setProgramID(newData[0]?.id);
      setTermDropdown(termData);
      setTerm(undefined);
    }
  };

  function handleIgnoreHolidayDialog() {
    setIgnoreHoliday((prevState) => !prevState);
  }
  function handleFilterProgramDialog() {
    setFilterProgram((prevState) => !prevState);
  }

  const handleCancel = (row, rows, index) => {
    setDisableAddActivity(false);
    const newData = [...rows];
    newData.pop((item) => item.id === row);
    setRows(newData);
  };
  function handleCloneDialog() {
    setCloneDialog((prevState) => !prevState);
  }

  // const masterImportDialog = (id) => {
  //   setMasterDialog(true);
  //   setLoading(false);
  //   if (!masterDialog) {
  //     setLoading(true);
  //     let querry = `?academicProgramId=${id}`;
  //     getMasterActivityWithTermData(querry)
  //       .then((res) => {
  //         console.log(res);
  //         let responseData = res?.message;
  //         if (responseData === 'No Data Found') {
  //           setMasterData([]);
  //         } else {
  //           let key = Object.keys(res);
  //           let values = Object.values(res);
  //           let alteredData = key.map((el, ind) => {
  //             return {
  //               courseName: el,
  //               array: [...values[ind]],
  //             };
  //           });
  //           console.log(alteredData, 'alteredData');
  //           setMasterData(alteredData);
  //         }
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //       });
  //   }
  // };
  const masterImportCancel = () => {
    setMasterData([]);
    setMasterDialog(false);
  };
  // const masterImportSubmit = () => {
  //   setLoading(true);
  //   const data = `?academicProgramId=${selectedAcademicProgram[0]?.id}&intake=${intake}&year=${year}`;
  //   getImportTermActivity(data)
  //     .then((res) => {
  //       handleSnackbarOpen('success', res.message);
  //       setLoading(false);
  //       setMasterImportSuccess(!masterImportSuccess);
  //       setMasterDialog(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // };
  const termStartDate = (e, item, index) => {
    const rowsData = [...rows];
    setRows((state) => {
      return rowsData.map((row) => {
        if (row.courseName === item.courseName) {
          return { ...row, termStart: e.target.value };
        }
        return row;
      });
    });
  };
  const termEndDate = (e, item, index) => {
    const rowsData = [...rows];
    setRows((state) => {
      return rowsData.map((row) => {
        if (row.courseName === item.courseName) {
          return { ...row, termEnd: e.target.value };
        }
        return row;
      });
    });
  };

  React.useEffect(() => {
    if (newAddActivity) {
      handleRefereceCreate('add', activitiesData);
    } else {
      setConfirmDialogAddReference(false);
    }
  }, [newAddActivity]);

  return (
    <Box style={{ width: '100%' }}>
      {loading && <KenLoader />}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {/* <Box mt={2} mb={2} className={classes.mainActions}>
        <Button
          className={classes.filterButton}
          variant="contained"
          color="primary"
          onClick={masterImportDialog}
          disabled={disableMaster}
        >
          Master Term Import
        </Button> 
      </Box> */}
      {/* TERM DATA */}
      {rows?.length > 0 ? (
        <Table sx={{ minWidth: 700 }} aria-label="spanning table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Week No.</TableCell>
              <TableCell align="left">Activity</TableCell>
              <TableCell align="left">Start Date</TableCell>
              <TableCell align="left">End Date</TableCell>
              <TableCell align="left">Faculty</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <TableRow key={row.activiteId}>
                  <KenGridEditable
                    {...{
                      row,
                      onChange,
                      columns: [
                        {
                          column_name: 'weekNo',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'Week No.',
                        },
                        {
                          column_name: 'activiteType',
                          is_inline_edit: false,
                          inline_edit_type: 'kenSelect',
                          dropdown: selectOptionsSubject,
                          label: 'Activity',
                        },
                        {
                          column_name: 'startDate',
                          is_inline_edit: false,
                          inline_edit_type: 'kenDatePicker',
                          label: 'Start Date',
                        },
                        {
                          column_name: 'endDate',
                          is_inline_edit: false,
                          inline_edit_type: 'kenDatePicker',
                          label: 'End Date',
                        },
                        {
                          column_name: 'facultyList',
                          is_inline_edit: true,
                          inline_edit_type: 'kenAutoComplete',
                          dropdown: facultyOptions,
                        },
                      ],
                    }}
                  />
                  <TableCell
                    className={classes.selectTableCell}
                    style={{ textAlign: 'center' }}
                  >
                    {row.isEditMode ? (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            onToggleEditMode('done', row.activiteId, index)
                          }
                        >
                          Save
                        </Button>
                        <IconButton
                          aria-label="revert"
                          onClick={() => onRevert(row.activiteId, rows, index)}
                        >
                          <RevertIcon />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        {!row.saved && (
                          <IconButton
                            aria-label="edit"
                            onClick={() =>
                              onToggleEditMode('edit', row.activiteId, index)
                            }
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {row.saved && (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleSubject('save', rows, index)}
                            >
                              Save
                            </Button>
                            <IconButton
                              aria-label="revert"
                              onClick={() =>
                                handleCancel(row.activiteId, rows, index)
                              }
                            >
                              <RevertIcon />
                            </IconButton>
                          </>
                        )}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : null}
      {/* Master Term Import */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Master Term Import
            </Typography>
          </>
        }
        open={masterDialog}
        icon={<RiCheckFill />}
        handleClose={() => masterImportCancel()}
        negativeButtonClick={() => masterImportCancel()}
        // positiveButtonClick={() => masterImportSubmit()}
        positiveButtonText="Import"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {masterData.length > 0 ? (
              masterData.map((elem, index) => {
                return (
                  <Accordion expanded={masterAccordian}>
                    <AccordionSummary expandIcon={masterAccordian}>
                      {masterAccordian ? (
                        <AiOutlineMinusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      ) : (
                        <AiOutlinePlusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      )}{' '}
                      &nbsp;{' '}
                      <span style={{ color: '#092682', font: 'Open Sans' }}>
                        {elem.courseName}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <KenGrid
                          columns={masterHead}
                          data={elem?.array}
                          pagination={{ disabled: true }}
                          toolbarDisabled={true}
                        />
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Accordion expanded={masterAccordian}>
                <AccordionSummary expandIcon={masterAccordian}>
                  {masterAccordian ? (
                    <AiOutlineMinusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <span style={{ color: '#092682', font: 'Open Sans' }}>
                    Term 1
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <KenGrid
                      columns={masterHead}
                      data={[]}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                    />
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </KenDialog>
      <Reference
        title={'Add Reference'}
        // children={}
        isOpen={confirmDialogAddReference}
        handleClose={() => setConfirmDialogAddReference(false)}
        // handleEvent={handleAddEventRefernce}
        positiveBtn={'Add'}
        negativeBtn={'Cancel'}
        handleSelectSubjectChange={handleSelectSubjectChange}
        sessions={sessions}
        activityTypes={selectOptionsSubject}
        id={null}
        subjects={subjects}
        subjectVal={currentRow?.courseName}
        termId={currentRow?.termId}
        selectedRow={selectedRow}
        selectedActivity={activitiesData}
        facultyOptions={facultyOptions}
        onSuccess={onSuccess}
        selectSubjectValue={selectSubjectValue}
        createNewActivity={createNewActivity}
        setCreateNewActivity={setCreateNewActivity}
      />
    </Box>
  );
};

export default AddActivity;